import React from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { Col } from '@amzn/atoz-web/Col';
import { useTranslation } from 'react-i18next';
import { useShiftDetailsModalContentData } from './useShiftDetailsModalContentData';
import { ShiftDetailsCard } from './ShiftDetailsCard';
import { ShiftIntervalList } from '../shared';
import { ShiftPayLink } from './ShiftPayLink';
import { ShiftPayBreakdown } from './ShiftPayBreakdown';
import { SpecialInstructions } from './SpecialInstructions';
import { BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
export var ShiftDetailsModalContent = function (_a) {
    var _b;
    var close = _a.close, footerButtons = _a.footerButtons, shiftStatusBanners = _a.shiftStatusBanners, setModalContent = _a.setModalContent, setModalError = _a.setModalError, shift = _a.shift, skills = _a.skills, payBreakdown = _a.payBreakdown, incentivePay = _a.incentivePay, scheduleShift = _a.scheduleShift, _c = _a.vtoOpportunities, vtoOpportunities = _c === void 0 ? [] : _c;
    var t = useTranslation().t;
    var _d = useShiftDetailsModalContentData({
        shift: shift,
        skills: skills,
        scheduleShift: scheduleShift,
        payBreakdown: payBreakdown
    }), displayPayBreakdown = _d.displayPayBreakdown, displayPayLink = _d.displayPayLink;
    return (React.createElement(ModalContent, { dataTestId: "ShiftDetailsModalContent", titleText: t('shift_management_features_ShiftDetailsModal_title'), buttons: footerButtons, onCloseButtonClick: function () {
            if (scheduleShift) {
                BIAnalytics.closeScheduledShiftDetail(shift.id);
            }
            else {
                BIAnalytics.closeShiftOpportunityDetail(shift.id);
            }
            close();
        }, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(Col, { gridGap: "S300" },
            React.createElement(Col, null,
                React.createElement(ShiftDetailsCard, { scheduleShift: scheduleShift, shift: shift, setModalContent: setModalContent, setModalError: setModalError, skills: skills, payBreakdown: payBreakdown, vtoOpportunities: vtoOpportunities }),
                React.createElement(ShiftIntervalList, { shiftIntervals: (_b = scheduleShift === null || scheduleShift === void 0 ? void 0 : scheduleShift.shiftIntervals) !== null && _b !== void 0 ? _b : [], filterWorkIntervals: false, hideIntervalSkill: false })),
            displayPayBreakdown && payBreakdown ? (React.createElement(ShiftPayBreakdown, { payBreakdown: payBreakdown })) : displayPayLink ? (React.createElement(ShiftPayLink, { close: close, incentivePay: incentivePay })) : null,
            React.createElement(SpecialInstructions, { specialInstructions: shift.site.specialInstructions }),
            shiftStatusBanners)));
};
